import { render, staticRenderFns } from "./ServicesComponent.vue?vue&type=template&id=1a49ba92&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./ServicesComponent.vue?vue&type=style&index=0&id=1a49ba92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49ba92",
  null
  
)

export default component.exports